<template>
  <div class="sidebar-actions">
    <!-- Avatar / Logo del harmony -->
    <div class="action-item avatar-item">
      <div :class="['avatar-ring', { 'avatar-ring-empty': !logoPath }]">
        <v-avatar size="36" :class="['avatar-img', { 'avatar-img-empty': !logoPath }]">
          <v-img v-if="logoPath" :src="logoPath" :alt="userName" />
          <v-icon v-else color="#888888" size="20"> mdi-account </v-icon>
        </v-avatar>
      </div>
    </div>

    <!-- Likes -->
    <div class="action-item" @click="handleLike">
      <div class="icon-wrapper">
        <v-icon :color="localIsLiked ? 'red' : 'white'" size="24">
          {{ localIsLiked ? "mdi-heart" : "mdi-heart-outline" }}
        </v-icon>
      </div>
      <span class="action-text">{{ formatCount(likes) }}</span>
    </div>

    <!-- Compartir -->
    <div class="action-item" @click="handleShare">
      <div class="icon-wrapper">
        <v-icon color="white" size="22"> mdi-share-variant </v-icon>
      </div>
      <span class="action-text">{{ shareText }}</span>
    </div>

    <!-- Volumen -->
    <div class="action-item" @click="toggleVolume">
      <div class="icon-wrapper">
        <v-icon color="white" size="22">
          {{ isMuted ? "mdi-volume-off" : "mdi-volume-high" }}
        </v-icon>
      </div>
      <span class="action-text">{{ isMuted ? $t('explore.muted') : $t('explore.volume') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarActions",
  props: {
    logoPath: {
      type: String,
      default: "",
    },
    userName: {
      type: String,
      default: "",
    },
    likes: {
      type: Number,
      default: 0,
    },
    isLiked: {
      type: Boolean,
      default: false,
    },
    editor: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shareText() {
      try {
        const translated = this.$t("explore.share");
        return translated && translated !== "explore.share" ? translated : "Share";
      } catch {
        return "Share";
      }
    },
  },
  data() {
    return {
      isMuted: this.muted,
      localIsLiked: this.isLiked,
    };
  },
  watch: {
    muted(newVal) {
      this.isMuted = newVal;
    },
    isLiked(newVal) {
      this.localIsLiked = newVal;
    },
  },
  methods: {
    handleLike() {
      if (this.editor) return;
      this.localIsLiked = !this.localIsLiked;
      this.$emit("like");
    },
    handleShare() {
      if (this.editor) return;
      this.$emit("share");
    },
    toggleVolume() {
      this.isMuted = !this.isMuted;
      this.$emit("toggle-volume", this.isMuted);
    },
    formatCount(count) {
      if (count >= 1000000) {
        return (count / 1000000).toFixed(1) + "M";
      }
      if (count >= 1000) {
        return (count / 1000).toFixed(1) + "k";
      }
      return (count || 0).toString();
    },
  },
};
</script>

<style scoped>
.sidebar-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  color: white;
  transition: transform 0.2s ease;
}

.action-item:active {
  transform: scale(0.9);
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
}

.action-text {
  font-size: 10px;
  font-weight: 500;
  margin-top: 1px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}

/* Avatar */
.avatar-item {
  margin-bottom: 2px;
}

.avatar-ring {
  padding: 2px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff00ff, #00ffff);
}

.avatar-ring-empty {
  background: #2a2a3a;
}

.avatar-img {
  border: 2px solid white;
}

.avatar-img-empty {
  border: 2px solid #3a3a4a;
  background: #1a1a2e;
}

/* Animación del corazón */
@keyframes heartBeat {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.2);
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.action-item .v-icon.red--text {
  animation: heartBeat 0.4s ease-in-out;
}
</style>
